__turbopack_context__.v({
  "checkboxGroup": "Checkbox-module-scss-module__MN3Koq__checkboxGroup",
  "checkboxIcon": "Checkbox-module-scss-module__MN3Koq__checkboxIcon",
  "checkboxInput": "Checkbox-module-scss-module__MN3Koq__checkboxInput",
  "checkboxLabel": "Checkbox-module-scss-module__MN3Koq__checkboxLabel",
  "checkboxWrapper": "Checkbox-module-scss-module__MN3Koq__checkboxWrapper",
  "errorText": "Checkbox-module-scss-module__MN3Koq__errorText",
  "large": "Checkbox-module-scss-module__MN3Koq__large",
  "richLabel": "Checkbox-module-scss-module__MN3Koq__richLabel",
  "root": "Checkbox-module-scss-module__MN3Koq__root",
  "small": "Checkbox-module-scss-module__MN3Koq__small",
});
